<template>
  <div class="consumerNotification" style="margin-top:220px;">
    <div class="a_jc comWidth">
      <div class="word-box">
        <!--  <h5>消費者告知書</h5> -->
        <div id="articleDetail" v-html="agreement.content"></div>
      </div>
    </div>
    <!--导航-->
    <Nav :titles="titles" :titleChild="titleChild" :navState="navState" :tipsState="tipsState"/>
  </div>
</template>

<script>
  import Nav from '@/components/Nav'
  import {articlesDetails} from '@/api/article';
export default {
  name: 'ConsumerNotification',
  components:{
     Nav
  },
  data () {
    return {
      tipsState:false,
      navState:true,
      titles: '消費者告知書',
      agreement:'',
      titleChild:[{name:'',src:''}],
      //协议id
      article:this.$route.query.id,
    }
  },
  methods:{
    /*获取协议内容*/
    getAgreement(){
      articlesDetails(this.article).then(res =>{
        this.titles = res.data.title;
        this.agreement = res.data;
      })
    },
  },
  created(){
    window.scrollTo(0,0)
    this.getAgreement()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.consumerNotification{
  .word-box{
    background: url(../assets/icon/gaozhishu_bg.jpg) no-repeat;
    background-size: cover;
    width: 100%;
    height: 812px;
    overflow: hidden;
    margin: 40px auto 110px auto;
    padding: 50px 60px;
    p{
      color: #707070;
      font-size: 16px;
      line-height: 30px;
      text-indent: 2em;
    }
    p:first-child{
      text-indent: 0;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/ConsumerNotification.vue